export default __webpack_public_path__ + "static/media/Product-1.0ca2e84d.jpg";